import BookLibrarySerializer from 'teacher-ui-client/serializers/book-library'

export default class BookLibraryShareSerializer extends BookLibrarySerializer {}
